(function () {
	'use strict';

	angular
	.module('core')
	.controller('homeCtrl', homeCtrl);

	homeCtrl.$inject = ['$http', '$scope', '$rootScope', '$q', '$timeout', '$route', 'Upload'];

	function homeCtrl($http, $scope, $root, $q, $timeout, $route, $upload) {
		var vm = $scope;
		$root.loading = true;

		vm.init = function() {
			$http.get('./services/projects.php?t='+(new Date()).getTime()).
			then(function(response){
				$root.loading = false;

				vm.projects = response.data;
			});
		}
		vm.init();
	}
})();